import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';

export type Getters = {
  isThreeMode(state: State): boolean
  isRenderingMode(state: State): boolean
}

export const getters: GetterTree<State, RootState> & Getters = {
  isThreeMode: (state) => state.isThreeMode,
  isRenderingMode: (state) => state.isRenderingMode
};
